<template>
      <div id="tren-crs">
      <h3>Magazines</h3>
      <h3 id="Right" @click="handleViewAll()"><a >View All...</a></h3>
      <div class="crs-swiper-container">
        
        <swiper :options="courseSwiper">
          <swiper-slide  id="course-swiper" class="card card-1" :key="index" v-for="(m ,index) in CurrentContent" >
              <div v-if="index < $store.state.FixedShow">
                  <img @click="handleBook" :src="$store.state.urlLink+m.bookId+'.png'" :alt="m.BookName" :kappa="m.BookName" :id="m.bookId"  class="swiper-lazy pointer">
              </div>

              <div v-else>
                  <img id="ViewMore" @click="handleViewAll()" src="images/View More(M).png" class="swiper-lazy pointer">
              </div>

            <!--<div class="swiper-lazy-preloader"></div>-->
            
          </swiper-slide>
        </swiper>
      </div>
    </div>
</template>

<script>
import db from '../firebase/firebaseinit'
export default {
    name: "my-list",
data(){
  return {
    
    CurrentContent : [], 

    books: [],
    courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        
        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      },
    }
  },
    computed: 
    {
      magazines()
      {
        for(var i = 0 ; i<this.$store.state.FixedShow+1; i++) // push extra so that, it will give more space for view more image
        {
          this.CurrentContent.push(books[i])
        }
        return this.CurrentContent
      },
    },

    methods: 
    {
      handleBook: function (e) 
      {
        this.$router.push({
          name: 'viewContent'
        })
        if(!e) e = window.event;
          var x = e.currentTarget;
        var book_id = x.id;
        localStorage.setItem('book', book_id);
        
        //this.$store.dispatch('setBookName', book_id);
      },

      handleViewAll()
      {
        //this.$store.state.ChooseGridView = "magazine";
        localStorage.setItem('viewAll', "Magazine");
        this.$router.push({
        name: "ViewAll"
        });
      },

    },

    //database
    created()
    {
      db.collection('books').orderBy('bookName').get().then(query => 
      {//.where('bookType','==', "Magazine")
          query.forEach(doc => 
          {
            if(doc.data().bookType == "Magazine")
            {
                const data = 
                {
                    id: doc.id,
                    bookId: doc.data().bookId,
                    bookName: doc.data().bookName,
                    bookType: doc.data().bookType,
                    datePublished: doc.data().datePublished,
                    flowpaper: doc.data().flowpaper,
                    genre: doc.data().genre,
                    imgLink: doc.data().imgLink,
                    language: doc.data().language,
                    rating: doc.data().rating,
                    reviews: doc.data().reviews
                }
                this.books.push(data)
            }

          })
  
          for(var i = 0 ; i<this.$store.state.FixedShow+1; i++) // push extra so that, it will give more space for view more image
          {
            this.CurrentContent.push(this.books[i])
          }
      })
    }
}
</script>

<style scoped>

h3,a
{
  color : white;
}

#Right
{
  position: absolute;
  text-align: right;
  right: 10.5%;
  color : white;
}


</style>



// WEBPACK FOOTER //
// magazines.vue?0628aa64